import './styles.scss'

import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useActions, useValues } from 'kea'
import { useMediaQuery } from 'react-responsive'

import Helmet from 'lib/tags/helmet'
import railsContext from 'lib/selectors/rails-context'

import How from './how'
import PhotoArea from './photo-area'
import MasterCategories from './master-categories'
import PopularCities from './popular-cities'
import LatestCourses from './latest-courses'
import LessonReviews from './lesson-reviews'
import IntroBoxes from './intro-boxes'
import TeacherSignupPromotion from './teacher-signup-promotion'
import PopularActivities from './popular-activities'

import sceneLogic from './logic'

const MAX_SMALL_WIDTH = 658
const MIN_MEDIUM_WIDTH = 659
const MAX_MEDIUM_WIDTH = 959
const MIN_LARGE_WIDTH = 960

export default function Homepage () {
  const { dpr } = useSelector(railsContext)

  const { toggleSmallScreen, toggleMediumScreen, toggleLargeScreen, setIsMounted } = useActions(sceneLogic)
  const {
    latestCourses,
    popularCities,
    helmet,
    startPage,
    popularActivities,
    isMounted,
    smallScreen,
    mediumScreen,
    largeScreen
  } = useValues(sceneLogic)

  const isSmallScreen = useMediaQuery({ maxWidth: MAX_SMALL_WIDTH })
  const isMediumScreen = useMediaQuery({ minWidth: MIN_MEDIUM_WIDTH, maxWidth: MAX_MEDIUM_WIDTH })
  const isLargeScreen = useMediaQuery({ minWidth: MIN_LARGE_WIDTH })

  useEffect(() => {
    setIsMounted()
  }, [setIsMounted])

  useEffect(() => {
    if (isSmallScreen !== smallScreen) {
      toggleSmallScreen()
    }
  }, [isSmallScreen, smallScreen, toggleSmallScreen])

  useEffect(() => {
    if (isMediumScreen !== mediumScreen) {
      toggleMediumScreen()
    }
  }, [isMediumScreen, mediumScreen, toggleMediumScreen])

  useEffect(() => {
    if (isLargeScreen !== largeScreen) {
      toggleLargeScreen()
    }
  }, [isLargeScreen, largeScreen, toggleLargeScreen])

  const activities = popularActivities.filter(({ subCategories }) => subCategories && subCategories.length !== 0)

  return (
    <div>
      <Helmet helmet={helmet} />
      {isMounted && <How />}
      <PhotoArea />
      <MasterCategories />
      {activities.length !== 0 ? <PopularActivities /> : null}
      <LatestCourses dpr={dpr} courses={latestCourses} />
      <LessonReviews dpr={dpr} />
      {startPage ? <IntroBoxes /> : ''}
      <TeacherSignupPromotion />
      {popularCities.length > 0 ? <PopularCities /> : null}
    </div>
  )
}
